import { useStore } from "vuex";

export type Auth = {
    isAuthorized: (permission: string) => boolean;
    isAuthorizedForOneOf: (...permissions: string[]) => boolean;
    getAuthUser: () => AuthUser;
    refreshSession: () => Promise<void>;
};

export function useAuth(): Auth {
    const store = useStore();

    function isAuthorized(permission: string) {
        return store.getters.isAuthorized(permission);
    }

    function isAuthorizedForOneOf(...permissions: string[]) {
        return store.getters.isAuthorizedForOneOf(...permissions);
    }

    function getAuthUser() {
        return store.getters.getAuthUser;
    }

    async function refreshSession() {
        return store.dispatch("refreshSession");
    }

    return {
        isAuthorized,
        isAuthorizedForOneOf,
        getAuthUser,
        refreshSession,
    };
}

// TODO: there are other properties in the user object that are not yet represented in this type
export type AuthUser = {
    accessToken: string;
    email: string;
    idToken: string;
    sourceIds: string[];
};
